import React, { useEffect, useState } from "react";
import styles from "../styles/PlayersModal.module.css";
import cross from "../images/cross.svg";
import PlayerInput from "./PlayerInput";
import { getSeatCounts } from "../api/formApi";
import { toast } from "react-toastify";

export default function PlayersModal({
  heroIds,
  setHeroIds,
  isOpen,
  onClose,
  onSubmit,
  isCyber = true,

  // обычные игры
  scheduleId = null,
  propMaxSeats = null,
  propTakenSeats = 0,

  // приватные игры
  isPrivateGame = false,
  minFriends = 3,
}) {
  const [maxSeats, setMaxSeats] = useState(0);
  const [takenSeats, setTakenSeats] = useState(0);

  const amountInputs = heroIds.length;

  const availableSeats = isPrivateGame
    ? minFriends
    : (maxSeats - takenSeats - 1);

  // seats для обычных игр
  useEffect(() => {
    if (isPrivateGame) return;

    if (scheduleId) {
      (async () => {
        try {
          const data = await getSeatCounts(scheduleId);
          setMaxSeats(data.data.countMaxPlace);
          setTakenSeats(data.data.countCurrentPlace);
        } catch (err) {
          console.error("Ошибка загрузки мест:", err);
        }
      })();
    } else if (propMaxSeats !== null) {
      setMaxSeats(propMaxSeats);
      setTakenSeats(propTakenSeats);
    }
  }, [scheduleId, propMaxSeats, propTakenSeats, isPrivateGame]);

  // урезаем heroIds если больше доступного
  useEffect(() => {
    if (availableSeats >= 0 && amountInputs > availableSeats) {
      setHeroIds(heroIds.slice(0, availableSeats));
    }
  }, [availableSeats, amountInputs, heroIds, setHeroIds]);

  // Esc
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  // lock scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleChange = (index, value) => {
    const updated = [...heroIds];
    updated[index] = value;
    setHeroIds(updated);
  };

  const handleRemove = (index) => {
    setHeroIds(heroIds.filter((_, i) => i !== index));
  };

  const handleAddInput = () => {
    if (amountInputs < availableSeats) {
      setHeroIds([...heroIds, ""]);
    }
  };

  const handleSubmit = () => {
    // 1) чистим пустые
    const normalized = heroIds
      .map((id) => String(id).trim())
      .filter(Boolean);

    // 2) дедуп только для зарегистрированных (>0)
    //    гостей (-1 / 0 если вдруг) НЕ схлопываем
    const seenRealIds = new Set();
    const result = [];

    for (const rawId of normalized) {
      const num = Number(rawId);

      // Гость / незарегистрированный — оставляем как есть (можно несколько)
      if (num <= 0 || Number.isNaN(num)) {
        result.push(rawId);
        continue;
      }

      // Зарегистрированный пользователь: убираем дубли
      if (!seenRealIds.has(num)) {
        seenRealIds.add(num);
        result.push(String(num));
      }
    }

    if (isPrivateGame) {
      if (result.length < minFriends) {
        toast.error(`Нужно добавить минимум ${minFriends} игроков`);
        return;
      }
      onSubmit(result);
      return;
    }

    if (result.length) onSubmit(result);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={onClose}>
          <img src={cross} alt="Закрыть" />
        </button>

        <h3 className={styles.title}>
          {isPrivateGame
            ? "ВЫБЕРИТЕ ДРУЗЕЙ"
            : `ВВЕДИТЕ ID ${!isCyber ? "Героя" : "Эджраннера"}`}
        </h3>

        <div>
          {availableSeats <= 0 ? (
            <p className="body">Свободных мест нет</p>
          ) : (
            <>
              {heroIds.map((id, index) => (
                <PlayerInput
                  key={index}
                  value={id}
                  onChange={(val) => handleChange(index, val)}
                  onRemove={() => handleRemove(index)}
                />
              ))}

              {amountInputs < availableSeats && (
                <button
                  className={`${styles.addHero} body`}
                  type="button"
                  onClick={handleAddInput}
                >
                  {isPrivateGame
                    ? "+ Добавить друга"
                    : `+ Добавить ${!isCyber ? "героя" : "Эджраннера"}`}
                </button>
              )}
            </>
          )}
        </div>

        {isPrivateGame && (
          <div className={styles.requirement}>
            <p className="body">
              Минимум {minFriends} игрока (всего {minFriends + 1} человек с вами)
            </p>
          </div>
        )}

        <button
          type="button"
          className={`btn btn-brown-noLine w-auto`}
          onClick={handleSubmit}
        >
          {isPrivateGame
            ? "ПОДТВЕРДИТЬ ВЫБОР"
            : `ЗАПИСАТЬ В ${!isCyber ? "Приключение" : "Миссию"}`}
        </button>
      </div>
    </div>
  );
}